import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { UIComponentsModule } from 'app/ui-components/ui-components.module';

import { AddWorkspaceComponent } from './add-workspace.component';
import { EditProjectComponent } from './edit-project.component';
import { EditTeamComponent } from './edit-team.component';
import { OrgService } from './org.service';
import { AddProjectComponent } from './project/add-project.component';
import { AddTeamComponent } from './team/add-team.component';
import { WorkspaceSwitcherComponent } from './workspace-switcher/workspace-switcher.component';
import { WorkspaceSwitcherService } from './workspace-switcher/workspace-switcher.service';
import { SharedModule } from '../shared/shared.module';

const components = [
  AddProjectComponent,
  WorkspaceSwitcherComponent,
  EditProjectComponent,
  AddWorkspaceComponent,
  AddTeamComponent,
  EditTeamComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    UIComponentsModule,
    ReactiveFormsModule,
    NgSelectModule,
    ReactiveFormsModule,
  ],
  declarations: components,
  providers: [OrgService, WorkspaceSwitcherService],
  exports: components,
})
export class OrgModule {}
